module.exports = __webpack_public_path__ + "img/avatar-1.c65a0f28.png";